module.exports = __webpack_public_path__ + "assets/align-bottom.38743c23.svg";